<template>
  <div class="repair-detail-page">
    <!-- 全屏加载遮罩 -->
    <div v-if="loading" class="page-loading">
      <van-loading type="spinner" size="36px" vertical>加载中...</van-loading>
    </div>

    <!-- 顶部导航栏：返回 + 工单号 -->
    <van-nav-bar
      :title="`工单详情 · ${woNo}`"
      left-text="返回"
      left-arrow
      fixed
      placeholder
      @click-left="goBack"
    />

    <!-- 工单头部卡片 -->
    <div class="header-card">
      <div class="header-title-row">
        <span class="wo-title">{{ eqpInfo.wo_name || eqpInfo.eqp_name }}</span>
        <span class="eqp-code" v-show="eqpInfo.eqp_code">{{
          eqpInfo.eqp_code
        }}</span>
      </div>
      <div class="header-sub">
        <span class="sub-wo-no">{{ eqpInfo.wo_no || woNo }}</span>
      </div>
      <div class="header-tag-row">
        <span class="mini-tag tag-repair">应急维修</span>
        <span
          v-if="statusText(eqpInfo.status)"
          class="tag"
          :class="statusClass(eqpInfo.status)"
        >
          {{ statusText(eqpInfo.status) }}
        </span>
        <span
          v-if="eqpInfo.is_quality_confirm == 1 && !eqpInfo.quality_confirm_emp_id"
          class="tag tag-quality"
        >需质量确认</span>
        <span
          v-else-if="eqpInfo.is_quality_confirm == 1 && eqpInfo.quality_confirm_emp_id"
          class="tag tag-quality-done"
        >已质量确认</span>
      </div>
    </div>

    <!-- 设备信息分组 -->
    <div class="section">
      <div class="section-title">
        <span class="title-bar"></span>
        <span>设备信息</span>
      </div>
      <div class="info-card">
        <div class="info-row">
          <span class="info-label">设备</span>
          <span class="info-value">{{ eqpInfo.eqp_name || "-" }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">设备编号</span>
          <span class="info-value eqp-code" v-show="eqpInfo.eqp_code">{{
            eqpInfo.eqp_code
          }}</span>
          <span class="info-value" v-show="!eqpInfo.eqp_code">-</span>
        </div>
        <div class="info-row">
          <span class="info-label">位置</span>
          <span class="info-value">{{ eqpInfo.factory_structure_name || "-" }}</span>
        </div>
        <div class="info-row" v-show="eqpInfo.execute_emp_name">
          <span class="info-label">维修人</span>
          <span class="info-value">{{
            eqpInfo.execute_emp_code + "-" + eqpInfo.execute_emp_name
          }}</span>
        </div>
        <div
          class="info-row info-row-last"
        
        >
          <span class="info-label">开始 / 结束</span>
          <span class="info-value">{{
            formatTimeToHourMinute(eqpInfo.response_time) +
            " / " +
            formatTimeToHourMinute(eqpInfo.process_end_time)
          }}</span>
        </div>
      </div>
    </div>

    <!-- 故障信息分组 -->
    <div class="section">
      <div class="section-title">
        <span class="title-bar"></span>
        <span>故障信息</span>
      </div>
      <div class="fault-card">
        <div class="fault-head">
          <span class="fault-title">故障信息</span>
          <span class="fault-category" v-show="faultCategoryName">{{
            faultCategoryName
          }}</span>
        </div>
        <div class="fault-desc" v-show="eqpInfo.fault_description">
          {{ eqpInfo.fault_description }}
        </div>
        <div class="fault-desc fault-empty" v-show="!eqpInfo.fault_description">
          暂无故障描述
        </div>
        <div class="fault-meta">
          <span class="stop-tag" v-show="eqpInfo.is_stop == 1">已停机</span>
          <span class="stop-tag stop-tag-no" v-show="eqpInfo.is_stop == 0"
            >未停机</span
          >
          <span class="fault-meta-text">
            报修人
            {{
              eqpInfo.create_emp_name
                ? eqpInfo.create_emp_code +
                  "-" +
                  eqpInfo.create_emp_name
                : "-"
            }}
          </span>
        </div>
        <div class="fault-remark" v-show="eqpInfo.extend_remark">
          备注：{{ eqpInfo.extend_remark }}
        </div>
      </div>
    </div>
   <!-- 维修记录 -->
    <div class="section">
      <div class="section-title">
        <span class="title-bar"></span>
        <span>维修记录</span>
      </div>

      <!-- 有数据：横向表格展示 -->
      <div
        v-if="repairRecordList.length"
        class="repair-table-wrap"
        @mousedown="onTableMouseDown"
      >
        <div class="repair-table">
          <div class="rt-head">
            <div class="rt-th rt-index">#</div>
            <div class="rt-th">故障分析</div>
            <div class="rt-th">维修内容</div>
            <div class="rt-th">维修人</div>
            <div class="rt-th">维修工时(小时)</div>
            <div class="rt-th">其他成本(元)</div>
            <div class="rt-th">改进建议</div>
            <div class="rt-th">是否解决</div>
            <div class="rt-th">附件</div>
            <div class="rt-th">操作</div>
          </div>
          <div class="rt-row" v-for="(item, idx) in repairRecordList" :key="item.id || idx">
            <div class="rt-td rt-index">{{ idx + 1 }}</div>
            <div class="rt-td">{{ item.fault_analysis || "-" }}</div>
            <div class="rt-td">{{ item.repair_content || "-" }}</div>
            <div class="rt-td">{{ fmtEmp(item) }}</div>
            <div class="rt-td">{{ item.repair_hours ?? "-" }}</div>
            <div class="rt-td">{{ item.other_cost_amount ?? "-" }}</div>
            <div class="rt-td">{{ item.improve_suggestion || "-" }}</div>
            <div class="rt-td">
              <span class="rt-tag" :class="item.is_resolved == 1 ? 'rt-tag-yes' : 'rt-tag-no'">
                {{ item.is_resolved == 1 ? "已解决" : "未解决" }}
              </span>
            </div>
            <div class="rt-td">
              <span
                v-if="fileIdCount(item)"
                class="rt-link"
                @click="openFileViewer(item)"
              >附件预览</span>
              <span v-else>-</span>
            </div>
            <div class="rt-td">
              <span
                class="rt-link rt-edit"
                :class="{ 'rt-disabled': !canEditRepairRecord }"
                @click="canEditRepairRecord && handleRepairEdit(item)"
              >编辑</span>
              <span
                class="rt-link rt-del"
                :class="{ 'rt-disabled': !canEditRepairRecord }"
                @click="canEditRepairRecord && handleRepairDelete(item)"
              >删除</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 无数据 -->
      <div v-else class="repair-empty">暂无维修记录</div>
      </div>
    <!-- 关联单据·派生链 -->
    <div class="section">
      <div class="section-title">
        <span class="title-bar"></span>
        <span>关联单据·派生链</span>
      </div>

      <!-- 有数据：显示关联工单列表 -->
      <div v-if="relatedWoList.length" class="related-list">
        <van-swipe-cell
          v-for="(item, idx) in relatedWoList"
          :key="item.id || idx"
        >
          <!-- 左滑的主内容：点了跳详情 -->
          <div class="related-card" @click="goToRelatedDetail(item)">
            <div class="related-info">
              <div class="related-title">{{ item.eqp_name }} · {{ item.eqp_code }}</div>
              <div class="related-sub">{{ item.wo_type_name || "派生维修工单" }}</div>
              <div class="related-no">{{ item.wo_no }}</div>
            </div>
            <van-icon name="arrow" class="related-arrow" />
          </div>
          <!-- 右侧滑出的操作按钮 -->
          <template #right>
            <button
              v-if="!bindDisabled"
              class="related-remove"
              @click.stop="handleRemoveBind(item)"
            >移除</button>
          </template>
        </van-swipe-cell>
      </div>

      <!-- 无数据：显示绑定按钮 -->
      <div v-else class="related-empty">
        <button
          class="btn-binding btn-binding-outline"
          :disabled="bindDisabled"
          @click="!bindDisabled && openBindPopup()"
        >
          绑定已有工单
        </button>
        <button
          class="btn-binding"
          :disabled="bindDisabled"
          @click="!bindDisabled && handleBindNew()"
        >
          绑定新工单
        </button>
      </div>
    </div>

    <!-- 流转记录 -->
    <div class="section">
      <div class="section-title">
        <span class="title-bar"></span>
        <span>流转记录</span>
      </div>
      <div class="timeline" v-if="StepRecordList.length">
        <div
          v-for="(item, idx) in StepRecordList"
          :key="idx"
          class="tl-item"
          :class="{ 'tl-item-last': idx === StepRecordList.length - 1 }"
        >
          <div class="tl-dot"></div>
          <div class="tl-body">
            <div class="tl-head">
              <span class="tl-title">{{ getStepRecord(item.to_status) }}</span>
              <span class="tl-time">{{ formatTimeToHourMinute(item.create_time) }}</span>
            </div>
            <div class="tl-desc">
              {{ getStepRecordEmp(item) }}
            </div>
          </div>
        </div>
      </div>
      <div class="timeline-empty" v-else>暂无流转记录</div>
    </div>

    <!-- 底部操作按钮（固定）：按状态显示 -->
    <div class="bottom-bar" v-if="eqpInfo.status >= 31 && eqpInfo.status <= 36">
      <!-- 31 未响应：取消工单 + 维修接单 -->
      <template v-if="eqpInfo.status === 31 && isRmeSupervisor === true">
        <button class="btn-secondary" :disabled="updating" @click="handleRevokeWo">取消工单</button>
        <button class="btn-primary" :disabled="updating" @click="handleAcceptOrder">维修接单</button>
      </template>
      <!-- 32 未分配：取消工单 + 安排人员 -->
      <template v-else-if="eqpInfo.status === 32 && isRmeSupervisor === true">
        <button class="btn-secondary" :disabled="updating " @click="handleRevokeWo">取消工单</button>
        <button class="btn-primary" :disabled="updating " @click="openAssignStaffDialog('assign')">安排人员</button>
      </template>
      <!-- 33 未到场：修改人员（主管） + 确认到场（执行人） -->
      <template v-else-if="eqpInfo.status === 33 && isRmeSupervisor === true && isRepairExecutor === true">
        <button class="btn-secondary" :disabled="updating" @click="openAssignStaffDialog('edit')">修改人员</button>
        <button class="btn-primary" :disabled="updating" @click="handleConfirmArrival">确认到场</button>
      </template>
      <template v-else-if="eqpInfo.status === 33 && isRmeSupervisor === true">
        <button class="btn-primary btn-full" :disabled="updating" @click="openAssignStaffDialog('edit')">修改人员</button>
      </template>
      <template v-else-if="eqpInfo.status === 33 && isRepairExecutor === true">
        <button class="btn-primary btn-full" :disabled="updating" @click="handleConfirmArrival">确认到场</button>
      </template>
      <!-- 34 待确认：确认故障 -->
      <template v-else-if="eqpInfo.status === 34 && isRepairExecutor==true">
        <button class="btn-primary btn-full" :disabled="updating" @click="handleConfirmFault">确认故障</button>
      </template>
      <!-- 35 维修中：维修完成 -->
      <template v-else-if="eqpInfo.status === 35 && isRepairExecutor==true">
         <button class="btn-secondary" :disabled="updating" @click="handleRepairExtend">维修录入</button>
        <button class="btn-primary" :disabled="updating" @click="openCompleteRepairDialog">维修完成</button>
      </template>
      <!-- 36 待验收：确认验收 -->
      <template v-else-if="eqpInfo.status === 36 && (eqpInfo.is_quality_confirm == 0 || (eqpInfo.is_quality_confirm == 1 && eqpInfo.quality_confirm_emp_id)) && isAcceptanceExecutor==true">
        <button class="btn-primary btn-full" :disabled="updating" @click="handleConfirmAcceptance">确认验收</button>
      </template>
    </div>

    <!-- 安排/修改人员弹框 -->
    <van-popup v-model:show="showAssignDialog" position="bottom" round>
      <van-cascader
        v-model="assignCascaderValue"
        title="请选择维修人员"
        :options="teamEmpOptions"
        :field-names="{ text: 'text', value: 'value', children: 'children' }"
        @close="showAssignDialog = false"
        @finish="onAssignFinish"
      />
    </van-popup>

    <!-- 故障确认弹框（独立组件） -->
    <FaultConfirmDialog
      v-model:show="showFaultDialog"
      :initial-data="eqpInfo"
      :company-id="eqpInfo.company_id"
      :submitting="updating"
      @confirm="onFaultConfirmSubmit"
    />

    <!-- 维修录入弹框（独立组件） -->
    <RepairExtendDialog
      v-model:show="showRepairExtendDialog"
      :initial-data="editingRecord || {}"
      :wo-id="eqpInfo.id"
      :submitting="updating"
      @confirm="onRepairExtendSubmit"
    />

    <!-- 附件预览弹层（fileView 组件） -->
    <van-popup v-model:show="showFileViewer" position="bottom" round :style="{ height: '50%' }">
      <div class="file-viewer">
        <div class="fv-header">
          <span class="fv-title">附件预览</span>
          <van-icon name="cross" @click="showFileViewer = false" />
        </div>
        <div class="fv-body">
          <FileView :file_id="viewerFileIds" />
        </div>
      </div>
    </van-popup>

    <!-- 维修完成弹框 -->
    <van-popup v-model:show="showCompleteDialog" position="bottom" round>
      <div class="complete-dialog">
        <div class="cd-header">
          <span class="cd-title">维修完成</span>
        </div>
        <div class="cd-body">
          <van-cell-group>
            <van-field label="是否质量确认">
              <template #right-icon>
                <van-switch
                  :model-value="completeForm.is_quality_confirm === 1"
                  @update:model-value="(v) => (completeForm.is_quality_confirm = v ? 1 : 0)"
                  size="22px"
                />
              </template>
            </van-field>
            <van-field label="是否点检确认">
              <template #right-icon>
                <van-switch
                  :model-value="completeForm.is_inspection_confirm === 1"
                  @update:model-value="(v) => (completeForm.is_inspection_confirm = v ? 1 : 0)"
                  size="22px"
                />
              </template>
            </van-field>
          </van-cell-group>
          <CheckWorkOrderForm
            v-if="completeForm.is_inspection_confirm === 1"
            ref="checkWorkOrderFormRef"
            :company_id="eqpInfo.company_id"
            :eqp_info_id="eqpInfo.eqp_info_id"
          />
        </div>
        <div class="cd-footer">
          <van-button block plain type="default" :disabled="updating" @click="showCompleteDialog = false">取消</van-button>
          <van-button block type="primary" :loading="updating" @click="onCompleteRepair">确定</van-button>
        </div>
      </div>
    </van-popup>

    <!-- 绑定已有工单弹框 -->
    <van-popup v-model:show="bindPopup.show" position="bottom" round :style="{ height: '75%' }">
      <div class="bind-popup">
        <van-nav-bar title="绑定已有工单" @click-left="cancelBind">
          <template #right>
            <span class="bind-total">共 {{ bindPopup.total }} 条</span>
          </template>
        </van-nav-bar>

        <!-- 切换当前/历史 -->
        <van-tabs v-model:active="bindPopup.activeRange" animated border @change="onBindRangeChange">
          <van-tab title="当前" name="current" />
          <van-tab title="历史" name="history" />
        </van-tabs>

        <!-- 搜索 -->
        <div class="bind-search">
          <van-search
            v-model="bindPopup.keyword"
            placeholder="请输入工单号"
            shape="round"
            @search="onBindSearch"
            @clear="onBindSearch"
          />
        </div>

        <!-- 列表 -->
        <van-list
          ref="bindListRef"
          :loading="bindLoading"
          :finished="!bindPopup.hasMore"
          finished-text="没有更多了"
          class="bind-list"
          @load="onBindLoadMore"
        >
          <van-empty v-if="bindPopup.list.length === 0 && !bindLoading" description="暂无数据" />
          <div
            class="bind-item"
            v-for="item in bindPopup.list"
            :key="item.id"
            :class="{ 'bind-item--active': bindPopup.selectedId === item.id }"
            @click="selectBindItem(item)"
          >
            <van-radio :name="item.id" :model-value="bindPopup.selectedId" />
            <div class="bind-item-body">
              <div class="bind-item-head">
                <span class="bind-wo-no">{{ item.wo_no }}</span>
                <span class="bind-status" :class="{'st-pending': item.status === 33, 'st-doing': item.status >= 34 && item.status <= 36, 'st-done': item.status >= 37}">
                  {{ item.status_name || "" }}
                </span>
              </div>
              <div class="bind-eqp">
                <span class="bind-eqp-name">{{ item.eqp_name || "-" }}</span>
                <span class="bind-eqp-code" v-if="item.eqp_code">{{ item.eqp_code }}</span>
              </div>
              <div class="bind-fault">{{ item.fault_name || "-" }}</div>
            </div>
          </div>
        </van-list>

        <!-- 底部确定 -->
        <div class="bind-footer">
          <van-button block type="primary" :disabled="!bindPopup.selectedId" @click="confirmBind">
            确定{{ bindPopup.selectedItem ? ` · ${bindPopup.selectedItem.wo_no}` : "" }}
          </van-button>
        </div>
      </div>
    </van-popup>

    <!-- 绑定新工单按钮已直接调用 /ems/repair 路由 -->
  </div>
</template>

<script>
import { ref, reactive, computed, watch, nextTick, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { Toast, Dialog, showImagePreview } from "vant";
import { GetWoRepairDataH5,GetWorkOrderStepRecord,InsertWoStepRecord,SavePmWoAssign,UpPmWoAssign,ConfirmPmWoArrival,GetWoRepairRecord,DelRepairRecord,ConfirmAcceptance,
GetTeamEmp,SaveRepairExtend,SaveRepairRecord ,GetPmWoByWoRelateRepairId,GetPmWoPageList,SubmitBindWo,CleaRelateRepair,CompleteRepairSubmit,GetAdminInfo} from "@/api/ems/eqpInfo.js";
import FaultConfirmDialog from "./FaultConfirmDialog.vue";
import RepairExtendDialog from "./RepairExtendDialog.vue";
import FileView from "@/components/fileView.vue";
import CheckWorkOrderForm from "../addCheckWorkOrder/CheckWorkOrderForm.vue";
import { UserStore } from "@/store/userStore";


export default {
  name: "EmsEmergencyRepairWorkOrder",
  components: { FaultConfirmDialog, RepairExtendDialog, FileView, CheckWorkOrderForm },
  setup() {
    const userStore = UserStore();
    const currentEmpId = ref("");
    const route = useRoute();
    const router = useRouter();

    // orders 跳转传 wo_id / wo_no / status / wo_type；兜底从 query 取
    const woId = ref(route.query.wo_id || "");
    const woNo = ref(route.query.wo_no || "");
    const loading = ref(true);
    const updating = ref(false);
    const eqpInfo = ref({});
    const StepRecordList = ref([]);
    const isRmeSupervisor = ref(false); //是否为维修主管  
    const goBack = () => {
      // 分享链接被直接打开时无站内历史（history.state.back 为空），兜底跳工作台
      if (window.history.state && window.history.state.back) {
        router.back();
      } else {
        router.replace({ path: "/ems/orders" });
      }
    };

    // 格式化时间为 月日时分（MM-DD HH:mm）
    const formatTimeToHourMinute = (timeStr) => {
      if (!timeStr) return "-";
      const match = timeStr.match(/(\d{4})[-/](\d{1,2})[-/](\d{1,2})[ T]?(\d{1,2}):(\d{1,2})/);
      if (match) {
        const mm = match[2].padStart(2, "0");
        const dd = match[3].padStart(2, "0");
        const hh = match[4].padStart(2, "0");
        const mi = match[5].padStart(2, "0");
        return `${mm}-${dd} ${hh}:${mi}`;
      }
      return timeStr;
    };

    // 获取工单基础信息
    const getWorkOrderDetail = async () => {
      console.log(woId.value, "获取工单基础信息页面跳转");
      const res = await GetWoRepairDataH5({ wo_id: woId.value });
      if (res.code == 200) {
        eqpInfo.value = res.data[0] || {};
      }
    };

    // 关联单据·派生链
    const relatedWoList = ref([]);
    const getRelatedWo = async () => {
      try {
        const res = await GetPmWoByWoRelateRepairId({ wo_id: woId.value });
        if (res.code == 200 && res.data) {
          // 接口可能返回数组或单对象，统一转数组
          const list = Array.isArray(res.data) ? res.data : [res.data];
          relatedWoList.value = list.filter(
            (item) => item && item.id && Object.keys(item).length > 0
          );
        } else {
          relatedWoList.value = [];
        }
      } catch (e) {
        relatedWoList.value = [];
      }
    };
    // 跳转关联单据详情
    const goToRelatedDetail = (item) => {
      console.log(item, "跳转关联单据详情");
        router.push({
          path: "/ems/workOrderInfo/emergencyRepairWorkOrder",
          query: {
            wo_id: item.id ?? item.wo_id ?? "",
            wo_no: item.wo_no ?? "",
            status: item.status ?? "",
            wo_type: item.wo_type ?? "",
          },
        });
    };
    // 绑定新工单：跳转应急报修页（带 from_wo_id）
    const handleBindNew = () => {
      router.push({ path: "/ems/repair", query: { from_wo_id: woId } });
    };
    // ===== 绑定已有工单弹窗 =====
    const bindListRef = ref(null);
    const bindLoading = ref(false); // 独立防并发，不跟 van-list 的 v-model 绑定
    const bindPopup = reactive({
      show: false,
      activeRange: "current",
      keyword: "",
      page: 1,
      pageSize: 20,
      total: 0,
      hasMore: true,
      list: [],
      selectedId: "",
      selectedItem: null,
    });

    // 打开弹窗：重置所有状态 + 手动触发第一次 load
    const openBindPopup = async () => {
      bindPopup.keyword = "";
      bindPopup.activeRange = "current";
      bindPopup.page = 1;
      bindPopup.total = 0;
      bindPopup.list = [];
      bindPopup.selectedId = "";
      bindPopup.selectedItem = null;
      bindPopup.hasMore = true;
      bindPopup.show = true;
      await nextTick();
      // van-popup 有过渡动画，再等一帧让弹层高度稳定后再触发
      requestAnimationFrame(() => {
        onBindLoadMore();
      });
    };

    // 不管是 van-list 自动触发还是我手动调，都走这里
    // 防并发用独立的 bindLoading，不跟 van-list 的 loading 状态耦合
    const onBindLoadMore = async () => {
      if (bindLoading.value) return;
      bindLoading.value = true;
      try {
        const res = await GetPmWoPageList({
          wo_no: bindPopup.keyword.trim(),
          wo_range: bindPopup.activeRange,
          wo_type: 3,
          page: bindPopup.page,
          pageSize: bindPopup.pageSize,
        });
        if (res && res.code == 200) {
          const rows = res.rows || res.data || [];
          bindPopup.total = res.total || rows.length;
          bindPopup.list = bindPopup.page === 1 ? rows : [...bindPopup.list, ...rows];
          bindPopup.hasMore = bindPopup.list.length < bindPopup.total && rows.length >= bindPopup.pageSize;
          bindPopup.page++;
        } else {
          bindPopup.hasMore = false;
        }
      } catch (e) {
        bindPopup.hasMore = false;
      } finally {
        bindLoading.value = false;
      }
    };

    // 切换当前/历史：重置 + 手动调
    const onBindRangeChange = async (v) => {
      bindPopup.activeRange = v; // van-tabs 用了 v-model:active，这里其实已同步，但为了安全再设一次
      bindPopup.page = 1;
      bindPopup.total = 0;
      bindPopup.list = [];
      bindPopup.hasMore = true;
      await nextTick();
      requestAnimationFrame(() => {
        onBindLoadMore();
      });
    };

    // 搜索：同上
    const onBindSearch = async () => {
      bindPopup.page = 1;
      bindPopup.total = 0;
      bindPopup.list = [];
      bindPopup.hasMore = true;
      await nextTick();
      requestAnimationFrame(() => {
        onBindLoadMore();
      });
    };

    const selectBindItem = (item) => {
      bindPopup.selectedId = item.id;
      bindPopup.selectedItem = item;
    };

    // 确定绑定：调 SubmitBindWo 把派生关系提交给后端
    const confirmBind = async () => {
      const sel = bindPopup.selectedItem;
      if (!sel) {
        Toast("请选择一条工单");
        return;
      }
      Toast.loading({ message: "绑定中...", forbidClick: true, duration: 0 });
      try {
        const res = await SubmitBindWo({
          source_wo_id: woId.value,
          bind_wo_id: sel.id,
        });
        Toast.clear();
        if (res && (res.success || res.code == 200)) {
          bindPopup.show = false;
          Toast(res.msg || "绑定成功");
          await getRelatedWo();
        } else {
          Toast.fail(res?.msg || "绑定失败");
        }
      } catch (e) {
        Toast.clear();
        Toast.fail("网络异常，请稍后重试");
      }
    };

    const cancelBind = () => {
      bindPopup.show = false;
    };

    // 移除关联绑定
    const handleRemoveBind = (item) => {
      if (bindDisabled.value) return;
      Dialog.confirm({
        title: "移除关联",
        message: `确认移除工单 ${item.wo_no || item.id} 的关联绑定？`,
        confirmButtonText: "移除",
        confirmButtonColor: "#f53f3f",
      })
        .then(async () => {
          Toast.loading({ message: "移除中...", forbidClick: true, duration: 0 });
          try {
            const res = await CleaRelateRepair({
              id: item.id,
              wo_id: woId.value,
            });
            Toast.clear();
            if (res && (res.success || res.code == 200)) {
              Toast(res.msg || "已移除");
              await getRelatedWo();
            } else {
              Toast.fail(res?.msg || "移除失败");
            }
          } catch (e) {
            Toast.clear();
            Toast.fail("网络异常，请稍后重试");
          }
        })
        .catch(() => {});
    };

    // 只有当前登录人是维修执行人且状态为 33/34/35/36 才允许绑定和移除工单
    const bindDisabled = computed(() => {
      const s = eqpInfo.value.status * 1;
      if (![33, 34, 35, 36].includes(s)) return true; 
      console.log("currentEmpId", currentEmpId.value);
      console.log("currentEmpId", eqpInfo.value.execute_emp_id);
      console.log("currentEmpId", eqpInfo.value.status);
      return String(eqpInfo.value.execute_emp_id) !== String(currentEmpId.value);
    });

    // 流转记录
    const getWorkOrderStepRecord = () => {
      StepRecordList.value = [];
      return GetWorkOrderStepRecord({ wo_id: woId.value }).then((res) => {
        if (res.code == 200) {
          StepRecordList.value = res.data || [];
        }
      });
    };

    // 工单状态码 -> 文案
    // 维修:31未响应 32未分配 33未到场 34待确认 35维修中 36待验收 37已完成 38已取消
    const STATUS_TEXT = {
      31: "未响应",
      32: "未分配",
      33: "未到场",
      34: "待确认",
      35: "维修中",
      36: "待验收",
      37: "已完成",
      38: "已取消",
    };

    // 工单状态码 -> 标签样式
    const STATUS_STYLE = {
      // 未响应：红底
      31: "tag-danger",
      // 未分配：灰底
      32: "tag-neutral",
      // 未到场：橙底
      33: "tag-pending",
      // 待确认 / 待验收：蓝底
      34: "tag-doing",
      // 维修中：红底
      35: "tag-danger",
      36: "tag-doing",
      // 已完成：绿底
      37: "tag-done",
      // 已取消：灰描边
      38: "tag-cancel",
    };

    // 流转记录 to_status -> 步骤名
    // 操作步骤：接单 → 维修安排 → 维修到场 → 确认故障 → 完成维修 → 生产确认并接受 → 已关闭
    const STEP_RECORD = {
      32: "接单",
      33: "维修安排",
      34: "维修到场",
      35: "确认故障",
      36: "完成维修",
      37: "生产确认并接受",
      38: "已取消",
    };


    const statusText = (status) => STATUS_TEXT[status] ?? "";
    const statusClass = (status) => STATUS_STYLE[status] ?? "";
    const getStepRecord = (status) => STEP_RECORD[status] ?? "";
    // 流转记录操作人：维修安排(to_status=33)显示被安排的维修人，其余显示记录操作人
    const getStepRecordEmp = (item) => {
      if (Number(item.to_status) === 33) {
        const code = eqpInfo.value.execute_emp_code || "";
        const name = eqpInfo.value.execute_emp_name || "";
        return code || name ? `${code}-${name}`.replace(/^-|-$/g, "") : "-";
      }
      return `${item.create_emp_code || ""}-${item.create_emp_name || ""}`.replace(/^-|-$/g, "") || "-";
    };

    // 故障分类名：优先取接口返回名称，兜底从路径快照最后一级取
    const faultCategoryName = computed(() => {
      if (eqpInfo.value.fault_name) return eqpInfo.value.fault_name;
      const path = eqpInfo.value.fault_tree_path_snapshot || "";
      const lastId = path.split(",").filter(Boolean).pop();
      return lastId ? `故障分类ID ${lastId}` : "";
    });

    // 构建步骤数据
    // step_type：取消时映射 37，其余取 from_status
    // event_seq：正常流转按 to_status-31（31→32=1, 32→33=2...36→37=6）
    //            取消按 from_status-30（31→38=1, 32→38=2）
    const buildStepData = (fromStatus, toStatus) => ({
      wo_id: eqpInfo.value.id,
      step_type: toStatus === 38 ? 37 : fromStatus,
      from_status: fromStatus,
      to_status: toStatus,
      event_seq: toStatus === 38 ? fromStatus - 30 : toStatus - 31,
      remark: "",
    });

    // 通用：确认弹窗 -> 插入步骤记录 -> 刷新
    const confirmAndUpdate = async (label, toStatus) => {
      try {
        await Dialog.confirm({
          title: `确认${label}`,
          message: `确定对工单 ${eqpInfo.value.wo_no || woNo} 执行「${label}」？`,
        });
        updating.value = true;
        const model = buildStepData(eqpInfo.value.status * 1, toStatus);
        let res=null;
        if(toStatus==37 || toStatus==38){
          console.log("model验收", model);
      res = await ConfirmAcceptance(model);//验收/取消
        }else if(toStatus==34){
            res = await ConfirmPmWoArrival({step:model});//确认到场
        }else{
          res = await InsertWoStepRecord(model);//插入步骤记录
        }
        
        if (res.code == 200) {
          Toast("操作成功");
          await Promise.allSettled([getWorkOrderDetail(), getWorkOrderStepRecord()]);
        } else {
          Toast(res.msg || "操作失败");
        }
      } catch (e) {
        console.log(e,"juu");
        if (e && e.code !== 200) Toast("操作失败");
      } finally {
        updating.value = false;
      }
    };

    // 安排/修改人员弹框
    const showAssignDialog = ref(false);
    const assignMode = ref("assign"); // 'assign' | 'edit'
    const assignCascaderValue = ref("");
    const teamEmpOptions = ref([]);

    // 将 GetTeamEmp 返回的数据映射为级联选择器结构
    // 2级：班组 → 员工；空班组过滤掉
    const mapTeamEmpTree = (nodes) =>
      (nodes || [])
        .filter((team) => team.children && team.children.length > 0)
        .map((team) => ({
          text: team.team_name?.trim() || "",
          value: team.team_id || "",
          children: (team.children || []).map((emp) => ({
            text: `${emp.emp_code || ""}-${emp.emp_name || ""}`,
            value: emp.team_emp_id || "",
            // 附带原始员工信息，finish 时取
            emp_id: emp.emp_id,
            emp_code: emp.emp_code,
            emp_name: emp.emp_name,
            team_emp_id: emp.team_emp_id,
          })),
        }));

    const loadTeamEmp = async () => {
      const res = await GetTeamEmp({});
      if (res.code == 200) {
        console.log(res.data, "人员列表");
        teamEmpOptions.value = mapTeamEmpTree(res.data || []);
      } else {
        teamEmpOptions.value = [];
      }
    };

    // 32→33 安排人员；33→33 修改人员
    const openAssignStaffDialog = async (mode) => {
      assignMode.value = mode;
      assignCascaderValue.value = "";
      showAssignDialog.value = true;
      if (!teamEmpOptions.value.length) {
        try {
          await loadTeamEmp();
        } catch (e) {
          Toast("加载人员列表失败");
          showAssignDialog.value = false;
        }
      }
    };
// 安排/修改人员确认
    const onAssignFinish = async ({ selectedOptions }) => {
      const empNode = selectedOptions && selectedOptions[selectedOptions.length - 1];
      if (!empNode) return;
  
    const submitData = {
      execute_emp_code: empNode.emp_code,
      execute_emp_name: empNode.emp_name,
      execute_emp_id: empNode.emp_id,
    }
      showAssignDialog.value = false;
      updating.value = true;
      console.log(submitData, "emp");
      try {
        let res;
    // 安排人员（新增）才传 step，修改人员不传
    if (assignMode.value === 'assign') {
      submitData.step = buildStepData(32, 33)
      res = await SavePmWoAssign(submitData)
    }else{
      submitData.wo_id = eqpInfo.value.id
      res = await UpPmWoAssign(submitData)
    }
    
        if (res.code == 200) {
          Toast("操作成功");
          await Promise.allSettled([
            getWorkOrderDetail(),
            getWorkOrderStepRecord(),
          ]);
        } else {
          Toast(res.msg || "操作失败");
        }
      } catch (e) {
        Toast("操作失败");
      } finally {
        updating.value = false;
      }
    };

    // 31 -> 32 维修接单
    const handleAcceptOrder = () => confirmAndUpdate("维修接单", 32);
    // 取消工单 -> 38
    const handleRevokeWo = () => confirmAndUpdate("取消工单", 38);
    // 33 -> 34 确认到场
    const handleConfirmArrival = () => confirmAndUpdate("确认到场", 34);
      // 36 -> 37 确认验收
    const handleConfirmAcceptance = () => confirmAndUpdate("确认验收", 37);
    // 故障确认弹框状态
    const showFaultDialog = ref(false);

    // 34 -> 35 确认故障:打开弹框
    const handleConfirmFault = () => {
      showFaultDialog.value = true;
    };

    // 故障确认弹框提交（子组件 emit confirm，payload 为表单值）
    const onFaultConfirmSubmit = async (formData) => {
      showFaultDialog.value = false;
      updating.value = true;
      try {
        // 推进工单状态 34→35
        const step = buildStepData(eqpInfo.value.status * 1, 35);
        // 非外部创建(is_external_created=0)时，受理人为工单报修人（子组件回传的 empData）；
        // 外部创建时用表单选择的外部人员
        const isExternal = formData.is_external_created == 1;
        const empData = formData.empData || {};
        const extend = {
          fault_tree_id: formData.fault_tree_id,
          fault_tree_path_snapshot: formData.fault_tree_path_snapshot,
          fault_description: formData.fault_description,
          is_stop: formData.is_stop,
          is_improve: formData.is_improve,
          is_external_created: formData.is_external_created,
          remark: formData.remark,
          id: formData.id,
          wo_id: formData.wo_id,
          accept_emp_id: isExternal ? formData.accept_emp_id : empData.id || "",
          accept_emp_code: isExternal ? formData.accept_emp_code : empData.emp_code || "",
          accept_emp_name: isExternal ? formData.accept_emp_name : empData.emp_name || "",
        };

        const model = { extend, step };
        const confirmRes = await SaveRepairExtend(model);
        if (confirmRes.code == 200) {
          Toast("确认成功");
          await Promise.allSettled([
            getWorkOrderDetail(),
            getWorkOrderStepRecord(),
          ]);
        } else {
          Toast(confirmRes.msg || "操作失败");
        }
      } catch (e) {
        console.error("故障确认提交失败", e);
        Toast("操作失败");
      } finally {
        updating.value = false;
      }
    };
  

    // 维修完成弹框
    const showCompleteDialog = ref(false);
    const checkWorkOrderFormRef = ref(null);
    // 维修完成弹框表单数据
    const completeForm = reactive({
      is_inspection_confirm: 0,//是否生成点检
      is_quality_confirm: 1,//是否确认质量
    });
    // 打开维修完成弹框
    const openCompleteRepairDialog = () => {
      if(eqpInfo.value.wo_type == 4){//工单类型为换线 必须生成点检
      completeForm.is_inspection_confirm = 1
      completeForm.is_quality_confirm = 1
    }
    else{
      completeForm.is_inspection_confirm = 0
      completeForm.is_quality_confirm = 1
    }
      showCompleteDialog.value = true;
    };
    // 维修完成弹框提交
     const onCompleteRepair = async () => {
       // 开启了点检确认时，先校验点检表单并取数
       let checkFormData = null;
       if (completeForm.is_inspection_confirm === 1 && checkWorkOrderFormRef.value) {
         const ok = await checkWorkOrderFormRef.value.validate();
         if (!ok) return; // 校验失败（Toast 已由子组件弹出）
         checkFormData = checkWorkOrderFormRef.value.getFormData();
       }
       showCompleteDialog.value = false;
       updating.value = true;
       console.log(checkFormData,"checkFormData组件回填数据");
       let wo={}
       let itemGroupIds=[]
       let teamIds=[]
   //点检组id
   itemGroupIds = (checkFormData.itemGroupDataList || []).map(item => item.id);
  //班组id
   teamIds = (checkFormData.teamDataList || []).map(item => item.id);
   wo={...eqpInfo.value}
       try {
        const step = buildStepData(35, 36)
        
         const res = await CompleteRepairSubmit({ step,wo, is_quality_confirm: completeForm.is_quality_confirm, is_inspection_confirm: completeForm.is_inspection_confirm ,itemGroupIds,teamIds});
         if (res.code == 200) {
           Toast("维修完成");
           await Promise.allSettled([
             getWorkOrderDetail(),
             getWorkOrderStepRecord(),
           ]);
         } else {
           Toast(res.msg || "操作失败");
         }
       } catch (e) {
         Toast("操作失败");
       } finally {
         updating.value = false;
       }
     };

    // 维修录入弹框状态
    const showRepairExtendDialog = ref(false);

    // 打开维修录入弹框（新增）
    const handleRepairExtend = () => {
      editingRecord.value = null;
      showRepairExtendDialog.value = true;
    };

    // ===== 维修记录列表 =====
    const repairRecordList = ref([]);
    const getRepairRecords = async () => {
      try {
        const res = await GetWoRepairRecord({ wo_id: woId.value });
        if (res.code == 200) {
          const data = Array.isArray(res.data)
            ? res.data
            : res.data && Object.keys(res.data).length
              ? [res.data]
              : [];
          repairRecordList.value = data;
        } else {
          repairRecordList.value = [];
        }
      } catch (e) {
        repairRecordList.value = [];
      }
    };

    // 维修人显示：STD6900-黄小红
    const fmtEmp = (item) => {
      const name =  item.create_emp_name;
      const code = item.create_emp_code;
      return name ? `${code}-${name}` : "-";
    };

    // 编辑维修记录：回填到弹框
    const editingRecord = ref(null);
    // 维修记录编辑/删除权限：工单状态为 35(维修中)，且当前操作人是维修执行人
    const canEditRepairRecord = computed(() => {
      const status = Number(eqpInfo.value.status);
      if (status !== 35 ) return false;
      return (
        !!currentEmpId.value &&
        String(eqpInfo.value.execute_emp_id || "") === String(currentEmpId.value)
      );
    });
    //当前登录人是维修执行人
    const isRepairExecutor = computed(() => {
       return (
        !!currentEmpId.value &&
        String(eqpInfo.value.execute_emp_id || "") === String(currentEmpId.value)
      );
    })
    //当前登录人是验收人或者填单人或者设备负责人
    const isAcceptanceExecutor = computed(() => {
       const isAlreadyBound = eqpInfo.value.create_emp_id == currentEmpId.value;

       const isAcceptanceExecutor = eqpInfo.value.accept_emp_id == currentEmpId.value;
       const isSupervisor = eqpInfo.value.supervisor_emp_id == currentEmpId.value;
       return (isAlreadyBound || isAcceptanceExecutor || isSupervisor);
    })
    // 维修记录编辑
    const handleRepairEdit = (item) => {
      if (!canEditRepairRecord.value) return;
      editingRecord.value = item;
      showRepairExtendDialog.value = true;
    };

    // 删除维修记录
    const handleRepairDelete = (item) => {
      if (!canEditRepairRecord.value) return;
      Dialog.confirm({
          title: `提示`,
          message: `确定删除该条维修记录吗？`,
        })
        .then(async () => {
          try {
            const res = await DelRepairRecord({ id: item.id });
            if (res.code == 200) {
              Toast("删除成功");
              getRepairRecords();
            } else {
              Toast(res.msg || "删除失败");
            }
          } catch (e) {
            Toast("删除失败");
          }
        })
        .catch(() => {});
    };

    // 附件数量（兼容 id 串 / 数组）
    const fileIdCount = (item) => {
      const raw = item.file_ids ?? "";
      if (typeof raw === "string") return raw.split(",").filter(Boolean).length;
      return 0;
    };

    // 附件预览：解析附件 id（兼容 id 串/数组），交给 fileView 组件展示
    const showFileViewer = ref(false);
    const viewerFileIds = ref("");
    const openFileViewer = (item) => {
      console.log(item,"item附件信息");
      const ids = item.file_ids ?? "";
      if (!ids) {
        Toast("暂无附件");
        return;
      }
      console.log(ids,"idskkkk");
      viewerFileIds.value = ids;
      showFileViewer.value = true;
    };

    // 鼠标拖拽横向滚动（PC 浏览器调试用，手机上触摸原生滚动）
    const onTableMouseDown = (e) => {
      const el = e.currentTarget;
      if (el.scrollWidth <= el.clientWidth) return;
      const startX = e.pageX;
      const startLeft = el.scrollLeft;
      el.style.cursor = "grabbing";
      el.style.userSelect = "none";
      const onMove = (ev) => {
        el.scrollLeft = startLeft + (ev.pageX - startX);
      };
      const onUp = () => {
        el.style.cursor = "grab";
        el.style.userSelect = "";
        window.removeEventListener("mousemove", onMove);
        window.removeEventListener("mouseup", onUp);
      };
      window.addEventListener("mousemove", onMove);
      window.addEventListener("mouseup", onUp);
    };

    // 维修录入弹框提交
    const onRepairExtendSubmit = async (payload) => {
      console.log(payload,"payload");
      console.log(payload.fileData,"fileData");
      const { fileData, ...formData } = payload;
      showRepairExtendDialog.value = false;
      updating.value = true;
      try {
        const repairData = {
          id: formData.id || "",
          wo_id: eqpInfo.value.id,
          start_time: formData.start_time,
          end_time: formData.end_time,
          is_resolved: formData.is_resolved,
          repair_hours: formData.repair_hours,
          fault_analysis: formData.fault_analysis,
          repair_content: formData.repair_content,
          other_cost_desc: formData.other_cost_desc,
          other_cost_amount: formData.other_cost_amount,
          improve_suggestion: formData.improve_suggestion,
          remark: formData.remark,
        };
        const model = { repairData, fileList: fileData };
        console.log(model,"modelwwwww");
        const res = await SaveRepairRecord(model);
        if (res.code == 200) {
          Toast("保存成功");
          await Promise.allSettled([
            getWorkOrderDetail(),
            getWorkOrderStepRecord(),
            getRepairRecords(),
          ]);
        } else {
          Toast(res.msg || "保存失败");
        }
      } catch (e) {
        Toast("保存失败");
      } finally {
        updating.value = false;
      }
    };

    onMounted(async () => {
      // 当前用户信息由路由守卫异步加载，这里兜底确保拿到后再取 user_id（延迟获取）
      if (Object.keys(userStore.userInfo || {}).length === 0) {
        await userStore.getUserInfo();
      }
      currentEmpId.value = userStore.userInfo?.user?.user_id || "";

      await Promise.allSettled([
        getWorkOrderDetail().catch(() => {
          Toast("加载详情失败");
        }),
        Promise.resolve(getWorkOrderStepRecord()),
        getRelatedWo().catch(() => {}),
        getRepairRecords().catch(() => {}),
      ]);
      loading.value = false;
      GetAdminInfo().then((res) => {
            const roles = res.data; 

        if (roles.includes("rme")) {
          isRmeSupervisor.value = true
        }
       
      });
    });

    // 同路由跳转关联单据详情时，监听 wo_id 变化刷新数据
    watch(
      () => route.query.wo_id,
      (newId) => {
        if (newId && newId !== woId.value) {
          woId.value = newId;
          woNo.value = route.query.wo_no || "";
          loading.value = true;
          Promise.allSettled([
            getWorkOrderDetail().catch(() => {}),
            getWorkOrderStepRecord(),
            getRelatedWo().catch(() => {}),
            getRepairRecords().catch(() => {}),
          ]).finally(() => {
            loading.value = false;
          });
        }
      }
    );

    return {
      woNo,
      woId,
      loading,
      updating,
      eqpInfo,
      StepRecordList,
      faultCategoryName,
      statusText,
      statusClass,
      getStepRecord,
      getStepRecordEmp,
      goBack,
      formatTimeToHourMinute,
      handleAcceptOrder,
      handleRevokeWo,
      handleConfirmArrival,
      handleConfirmFault,
      handleConfirmAcceptance,
      openAssignStaffDialog,
      openCompleteRepairDialog,
      showAssignDialog,
      teamEmpOptions,
      assignCascaderValue,
      onAssignFinish,
      // 关联单据
      relatedWoList,
      goToRelatedDetail,
      handleBindNew,
      openBindPopup,
      bindDisabled,
      // 绑定已有工单弹窗
      bindPopup,
      onBindRangeChange,
      onBindSearch,
      onBindLoadMore,
      selectBindItem,
      confirmBind,
      cancelBind,
      handleRemoveBind,
      // 故障确认弹框
      showFaultDialog,
      onFaultConfirmSubmit,
      // 维修录入弹框
      showRepairExtendDialog,
      onRepairExtendSubmit,
      handleRepairExtend,
      // 维修记录
      repairRecordList,
      fmtEmp,
      editingRecord,
      canEditRepairRecord,
      isRepairExecutor,
      isAcceptanceExecutor,
      handleRepairEdit,
      handleRepairDelete,
      fileIdCount,
      openFileViewer,
      showFileViewer,
      viewerFileIds,
      onTableMouseDown,
      // 维修完成弹框
      showCompleteDialog,
      checkWorkOrderFormRef,
      completeForm,
      openCompleteRepairDialog,
      onCompleteRepair,
      isRmeSupervisor, // 是否为应急维修主管
    };
  },
};
</script>

<style scoped lang="scss">
/* 维修完成弹框 */
.complete-dialog {
  padding-bottom: env(safe-area-inset-bottom);

  .cd-header {
    padding: 16px;
    text-align: center;
    border-bottom: 1px solid #ebedf0;

    .cd-title {
      font-size: 16px;
      font-weight: 600;
      color: #1d2129;
    }
  }

  .cd-body {
    padding: 8px 0;
  }

  .cd-footer {
    display: flex;
    gap: 12px;
    padding: 12px 16px;
    border-top: 1px solid #ebedf0;
    background: #fff;
  }
}

/* 全屏加载遮罩 */
.page-loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  z-index: 2000;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}

.repair-detail-page {
  min-height: 100%;
  background: #f7f8fa;
  padding-bottom: 64px;
}

/* ============ 工单头部卡片 ============ */
.header-card {
  margin: 12px;
  padding: 16px;
  background: #fff;
  border-radius: 12px;
}

.header-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.wo-title {
  font-size: 14px;
  font-weight: 700;
  color: #1d2129;
}

.header-sub {
  margin-top: 6px;
  font-size: 12px;
  color: #86909c;

  .sub-wo-no {
    color: #969799;
  }
}

.header-tag-row {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.mini-tag {
  padding: 2px 8px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 5px;
}

/* 应急维修类型标签：红描边 */
.tag-repair {
  border: 1px solid #ff7d7d;
  color: #ee0a24;
  background: #fff;
}

.tag {
  padding: 3px 10px;
  border-radius: 5px;
  font-size: 12px;
  line-height: 1.5;
  font-weight: 600;
}

/* 状态标签：柔和底色胶囊 */
.tag-danger {
  background: #fdecec;
  color: #ee0a24;
}

.tag-pending {
  background: #fff3e6;
  color: #e89030;
}

.tag-doing {
  background: #e8f3ff;
  color: #1989fa;
}

.tag-done {
  background: #e6f7ec;
  color: #07b35c;
}

.tag-neutral {
  background: #f2f3f5;
  color: #969799;
}

.tag-cancel {
  border: 1px solid #dcdee2;
  color: #a8abb2;
  background: #fff;
}

/* 需质量确认标签：紫色调，醒目区分 */
.tag-quality {
  background: #f5e8ff;
  color: #7c3aed;
}

/* 已质量确认标签：绿色调 */
.tag-quality-done {
  background: #e6f7ec;
  color: #07b35c;
}

/* ============ 分组标题 ============ */
.section {
  padding: 0 12px;
  margin-top: 4px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px 4px 8px;
  font-size: 15px;
  font-weight: 600;
  color: #1d2129;
}

.title-bar {
  width: 3px;
  height: 14px;
  border-radius: 2px;
  background: #1989fa;
}

/* ============ 关联单据·派生链 ============ */
/* 维修记录表格（横向滚动） */
.repair-table-wrap {
  background: #fff;
  border-radius: 8px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  cursor: grab;

  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c9cdd4;
    border-radius: 2px;
  }
}

.repair-table {
  min-width: 980px;
}

.rt-head,
.rt-row {
  display: flex;
  align-items: stretch;
}

.rt-head {
  background: #f7f8fa;
  position: sticky;
  top: 0;
  z-index: 1;
}

.rt-th,
.rt-td {
  flex: 1;
  min-width: 110px;
  padding: 8px 10px;
  font-size: 12px;
  color: #1d2129;
  word-break: break-all;
  display: flex;
  align-items: center;
}

.rt-th {
  font-weight: 600;
  color: #4e5969;
}

.rt-index {
  flex: 0 0 36px;
  min-width: 36px;
  justify-content: center;
}

.rt-row {
  border-top: 1px solid #f0f0f0;

  .rt-td {
    color: #4e5969;
  }
}

.rt-link {
  color: #1989fa;
  margin-right: 10px;

  &:last-child {
    margin-right: 0;
  }
}

.rt-edit {
  color: #ff976a;
}

.rt-del {
  color: #ee0a24;
}

/* 无编辑/删除权限：置灰禁用 */
.rt-link.rt-disabled {
  color: #c8c9cc;
  pointer-events: none;
}

.rt-tag {
  padding: 1px 6px;
  border-radius: 3px;
  font-size: 11px;

  &.rt-tag-yes {
    background: #e8ffea;
    color: #00b42a;
  }

  &.rt-tag-no {
    background: #fff7e8;
    color: #ff7d00;
  }
}

.repair-empty {
  background: #fff;
  border-radius: 8px;
  text-align: center;
  font-size: 12px;
  color: #c9cdd4;
  padding: 24px 0;
}

.related-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.related-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  cursor: pointer;

  &:active {
    background: #f7f8fa;
  }

  .related-info {
    flex: 1;
    min-width: 0;
  }

  .related-title {
    font-size: 14px;
    font-weight: 600;
    color: #1d2129;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .related-sub {
    margin-top: 4px;
    font-size: 12px;
    color: #86909c;
  }

  .related-no {
    margin-top: 4px;
    font-size: 12px;
    color: #4e5969;
    font-family: monospace;
  }

  .related-arrow {
    flex-shrink: 0;
    color: #c9cdd4;
    font-size: 14px;
  }
}

.related-remove {
  width: 64px;
  height: 100%;
  font-size: 14px;
  color: #fff;
  background: #f53f3f;
  border: none;
  border-radius: 0 10px 10px 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:active {
    background: #e13b3b;
  }
}

.related-empty {
  display: flex;
  gap: 10px;
  padding: 8px 0;
}

.btn-binding {
  flex: 1;
  height: 38px;
  border-radius: 8px;
  border: none;
  background: #1989fa;
  color: #fff;
  font-size: 13px;
  cursor: pointer;

  &:active {
    background: #1578e0;
  }

  &.btn-binding-outline {
    background: #fff;
    border: 1px solid #1989fa;
    color: #1989fa;

    &:active {
      background: #eaf3ff;
    }
  }

  &:disabled {
    background: #c9cdd4;
    color: #fff;
    border-color: #c9cdd4;
    cursor: not-allowed;
    opacity: 0.7;

    &.btn-binding-outline {
      background: #f7f8fa;
      color: #c9cdd4;
      border-color: #dcdee0;
    }
  }
}

/* ============ 设备信息 ============ */
.info-card {
  background: #fff;
  border-radius: 10px;
  padding: 4px 0;
  overflow: hidden;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  font-size: 14px;
  color: #1d2129;
  border-bottom: 1px solid #f2f3f5;

  &:last-child {
    border-bottom: none;
  }

  .info-label {
    color: #4e5969;
    flex-shrink: 0;
  }

  .info-value {
    text-align: right;
    max-width: 60%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

/* 设备编号胶囊 */
.eqp-code {
  padding: 2px 8px;
  background: #eaf3ff;
  color: #1989fa;
  font-size: 11px;
  border-radius: 6px;
  white-space: nowrap;
  max-width: none;
}

/* ============ 故障信息（红色警示卡） ============ */
.fault-card {
  background: #fdecec;
  border-radius: 10px;
  padding: 12px 16px;
}

.fault-head {
  display: flex;
  align-items: center;
  gap: 6px;
}

.fault-title {
  font-size: 13px;
  font-weight: 600;
  color: #ee0a24;
}

.fault-category {
  font-size: 12px;
  color: #ee0a24;
}

.fault-desc {
  margin-top: 8px;
  font-size: 13px;
  color: #1d2129;
  line-height: 1.6;
  word-break: break-all;

  &.fault-empty {
    color: #c9cdd4;
  }
}

.fault-meta {
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.stop-tag {
  padding: 1px 6px;
  font-size: 11px;
  border-radius: 4px;
  background: #ee0a24;
  color: #fff;
  flex-shrink: 0;

  &.stop-tag-no {
    background: #f2f3f5;
    color: #969799;
  }
}

.fault-meta-text {
  font-size: 12px;
  color: #4e5969;
}

.fault-remark {
  margin-top: 6px;
  font-size: 12px;
  color: #86909c;
  line-height: 1.5;
  word-break: break-all;
}

/* ============ 底部按钮 ============ */
.bottom-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px 16px;
  padding-bottom: calc(10px + env(safe-area-inset-bottom));
  background: #fff;
  box-shadow: 0 -1px 6px rgba(0, 0, 0, 0.04);
  z-index: 100;
  display: flex;
  gap: 12px;
}

.bottom-placeholder {
  height: 64px;
}

.btn-primary {
  border: none;
  cursor: pointer;
  flex: 1;
  height: 44px;
  border-radius: 22px;
  background: #1989fa;
  color: #fff;
  font-size: 16px;
  font-weight: 600;

  &:active {
    background: #1578e0;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &.btn-full {
    width: 100%;
    flex: none;
  }
}

.btn-secondary {
  flex: 1;
  height: 44px;
  border-radius: 22px;
  border: 1px solid #dcdee2;
  background: #fff;
  color: #4e5969;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;

  &:active {
    background: #f2f3f5;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

/* ============ 流转记录 · 纵向时间线 ============ */
.timeline {
  background: #fff;
  border-radius: 10px;
  padding: 16px 16px 4px;
}

.timeline-empty {
  background: #fff;
  border-radius: 10px;
  padding: 24px 0;
  text-align: center;
  font-size: 13px;
  color: #c9cdd4;
}

.tl-item {
  position: relative;
  padding: 0 0 18px 20px;

  /* 左侧竖线：最后一条不画 */
  &::before {
    content: "";
    position: absolute;
    left: 5px;
    top: 12px;
    bottom: -6px;
    width: 1px;
    background: #e5e6eb;
  }

  &.tl-item-last::before {
    display: none;
  }
}

.tl-dot {
  position: absolute;
  left: 0;
  top: 4px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #1989fa;
  box-shadow: 0 0 0 2px rgba(25, 137, 250, 0.18);
}

.tl-body {
  font-size: 14px;
}

.tl-head {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
}

.tl-title {
  font-size: 14px;
  font-weight: 600;
  color: #1d2129;
}

.tl-time {
  flex-shrink: 0;
  font-size: 13px;
  color: #86909c;
}

.tl-desc {
  margin-top: 4px;
  font-size: 13px;
  color: #86909c;
  line-height: 1.5;
}

/* ============ 绑定已有工单弹窗 ============ */
.bind-popup {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f7f8fa;

  .bind-total {
    font-size: 12px;
    color: #86909c;
  }

  .bind-search {
    padding: 8px 12px;
    background: #fff;
    border-bottom: 1px solid #f0f0f2;
  }

  .bind-list {
    flex: 1;
    overflow: auto;
  }

  .bind-item {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 12px 14px;
    margin: 8px 10px 0;
    background: #fff;
    border-radius: 10px;
    cursor: pointer;
    border: 2px solid transparent;
    transition: border-color 0.15s;

    &:active {
      background: #f7f8fa;
    }

    &.bind-item--active {
      border-color: #1989fa;
      background: #f0f8ff;
    }

    .bind-item-body {
      flex: 1;
      min-width: 0;
    }

    .bind-item-head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      margin-bottom: 4px;
    }

    .bind-wo-no {
      font-size: 13px;
      font-weight: 600;
      color: #1d2129;
      font-family: Menlo, Consolas, monospace;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .bind-status {
      font-size: 11px;
      padding: 2px 8px;
      border-radius: 4px;
      flex-shrink: 0;

      &.st-pending {
        background: #fff3e6;
        color: #e89030;
      }
      &.st-doing {
        background: #e8f3ff;
        color: #1989fa;
      }
      &.st-done {
        background: #e6f7ec;
        color: #07b35c;
      }
    }

    .bind-eqp {
      display: flex;
      align-items: center;
      gap: 6px;
      margin-bottom: 3px;

      .bind-eqp-name {
        font-size: 12px;
        color: #4e5969;
      }

      .bind-eqp-code {
        font-size: 11px;
        padding: 1px 6px;
        border-radius: 3px;
        background: #f2f3f5;
        color: #86909c;
        font-family: Menlo, Consolas, monospace;
      }
    }

    .bind-fault {
      font-size: 12px;
      color: #86909c;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .bind-footer {
    padding: 10px 14px calc(10px + env(safe-area-inset-bottom));
    background: #fff;
    border-top: 1px solid #f0f0f2;
  }
}
</style>
